import { ITournamentPrizes } from '@fantaz/shared/data-access/models';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as PrizesActions from './prizes.actions';

export const PRIZES_FEATURE_KEY = 'prizes';

export interface PrizesState extends EntityState<ITournamentPrizes> {
  selectedId?: string | number; // which Prizes record has been selected
  loaded: boolean; // has the Prizes list been loaded
  loading: boolean; // has the Prizes list been loaded
  error?: string | null; // last known error (if any)
  total: number; // last known error (if any)
  totalPrizeAmount: number; // last known error (if any)
}

export interface PrizesPartialState {
  readonly [PRIZES_FEATURE_KEY]: PrizesState;
}

export const prizesAdapter: EntityAdapter<ITournamentPrizes> =
  createEntityAdapter<ITournamentPrizes>({
    selectId: ({ uuid }) => uuid,
  });

export const initialPrizesState: PrizesState = prizesAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  total: 0,
  loading: false,
  totalPrizeAmount: 0,
});

const reducer = createReducer(
  initialPrizesState,
  on(PrizesActions.init, (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
  })),
  on(PrizesActions.loadPrizesSuccess, (state, { prizes }) =>
    prizesAdapter.setAll(prizes.Logs, {
      ...state,
      loaded: true,
      loading: false,
      total: prizes.total,
      totalPrizeAmount: prizes.totalPrizeAmount,
    }),
  ),
  on(PrizesActions.loadPrizesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);

export function prizesReducer(state: PrizesState | undefined, action: Action) {
  return reducer(state, action);
}
